import type { PublicApiKey } from '#packages/apilib';
import type { createPromoteApi } from './promotePublicApi';

export const PromoteApiKey: PublicApiKey<typeof createPromoteApi> = {
  name: 'PromoteApi',
  public: true,
};
